import { Dialog } from "@win-reality/react-ui";

import { SUPPORT_EMAIL, SUPPORT_PHONE } from "@/lib/constants";

interface SignupFailureModalProps {
  isOpen: boolean;
  onRetry: () => void;
  onClose: () => void;
  isLoading?: boolean;
}

const SignupFailureModal = ({
  isOpen,
  onRetry,
  onClose,
  isLoading = false,
}: SignupFailureModalProps) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
      title="Account Creation Failed"
      defaultCancelButton={false}
      size="md"
      primaryAction={{
        label: "Retry",
        onClick: onRetry,
        isLoading,
        isDisabled: isLoading,
      }}
    >
      <div className="space-y-3 text-sm">
        <p className="text-gray-700">
          We encountered a problem while setting up your account. Please try
          again or contact our support team:
        </p>

        <div className="space-y-1">
          <p className="text-gray-900">
            <span className="font-medium">Email:</span>{" "}
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="text-blue-600 hover:underline"
            >
              {SUPPORT_EMAIL}
            </a>
          </p>
          <p className="text-gray-900">
            <span className="font-medium">Phone:</span>{" "}
            <a
              href={`tel:${SUPPORT_PHONE}`}
              className="text-blue-600 hover:underline"
            >
              {SUPPORT_PHONE}
            </a>
          </p>
        </div>
      </div>
    </Dialog>
  );
};

export default SignupFailureModal;
